export interface IRequestReviewUnlock {

}

export class IRequestReviewUnlockForm {
  Id: string = "";

  constructor(Id?: string) {
    if (Id) {
      this.Id = Id;
    }
    Object.assign(this);
  }
}
